export function showCommand() {

    const showCommandBtns = document.querySelectorAll('.js-commandCardsShow');

    showCommandBtns.forEach( item => {
        const wrapper = item.parentNode.querySelector('.js-commandCards');
        const cardsCount = wrapper.querySelectorAll('[am-card="command-page"]').length;

        if (cardsCount < 10) {
            return false;
        }

        item.classList.add('is-active');

        item.addEventListener('click', () => {
            wrapper.classList.toggle('is-active');
            let text = wrapper.classList.contains('is-active') ? 'Скрыть' : 'Показать ещё';
            item.textContent = text;
        });
    });
}